import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';

import type {
  TextEffectsSharedDefinition,
  TextEffectsSharedMapperProps,
} from '../TextEffectsShared.types';
import type { LinkProps } from '@wix/editor-elements-definitions';

export const props = withCompInfo<
  TextEffectsSharedMapperProps,
  TextEffectsSharedDefinition,
  { link: LinkProps }
>()(['compData'], ({ compData }, carmiData) => {
  return {
    ...compData,
    ...carmiData,
  };
});

export const stateRefs = withStateRefsValues(['reducedMotion']);

export default createComponentMapperModel({
  props,
  stateRefs,
});
